import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectManagerMachinery } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const ProjectManagerMachinerySlice = createSlice({
  name: "ProjectManagerMachinery",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectManagerMachinery.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectManagerMachinery.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProjectManagerMachinery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export default ProjectManagerMachinerySlice.reducer;
